import { useSearchParams } from "react-router-dom";

function useTimeZone() {
  const [searchParams, setSearchParams] = useSearchParams();

  const timeZone = searchParams.get("timeZone") || "local";

  const changeTimeZone = (timeZone) => {
    searchParams.set("timeZone", timeZone);
    setSearchParams(searchParams);
  };

  return { timeZone, changeTimeZone };
}

export default useTimeZone;
